import { render } from "./BaseInputFile.vue?vue&type=template&id=262753e0"
import script from "./BaseInputFile.vue?vue&type=script&lang=js"
export * from "./BaseInputFile.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__